import type { JSX } from 'react';
import { AppRow, RAISONS_ACCES, useAccesPort } from '@taki/ui';
import type { ShellAppEntry } from '../types.js';

export interface AppsScreenProps {
  /** Apps A AFFICHER : deja filtrees (deprecated, acces, masquage DEV). */
  apps: readonly ShellAppEntry[];
  /**
   * Apps INSTALLEES, liste complete et non filtree. Sert au seul etat vide :
   * sans elle, « aucune app installee » et « aucune app accessible » se
   * ressemblent a l'ecran, et l'utilisateur croit son environnement vide alors
   * qu'il n'a simplement aucun droit. Absente : l'ecran retombe sur `apps`.
   */
  installedApps?: readonly ShellAppEntry[];
  /** Selection d'une app : navigue vers /app/$appId. */
  onPickApp: (appId: string) => void;
}

/**
 * Ecran "Apps" : liste editoriale d'AppRow, une par app installee. Chaque
 * ligne porte la pastille d'icone de l'app + son nom. Un clic navigue vers
 * l'app montee (`/app/$appId`).
 *
 * DEUX VIDES QUI NE SE DISENT PAS PAREIL. Une org sans app installee n'a rien
 * a montrer ; un utilisateur sans droit, lui, voit un ecran vide alors que
 * l'org est pleine. Le second doit DIRE sa raison (G16 : on explique, on ne
 * cache pas), sinon la seule conclusion possible est « c'est casse ».
 */
export function AppsScreen({ apps, installedApps, onPickApp }: AppsScreenProps): JSX.Element {
  const acces = useAccesPort();

  if (apps.length === 0) {
    const installees = installedApps ?? apps;
    // Le port doit avoir LU la fiche : avant, on ne sait rien, et accuser
    // l'acces d'un vide qu'on n'a pas constate serait pire que se taire.
    const sansAcces =
      acces !== null &&
      acces.pret &&
      installees.length > 0 &&
      installees.every((entry) => acces.niveauApp(entry.id) === 'none');

    return (
      <p className="text-sm text-ink-500">
        {installees.length === 0
          ? "Aucune app n'est installee pour cette organisation."
          : sansAcces
            ? `${RAISONS_ACCES.appSansAcces} Demande a un administrateur de t'ouvrir une app.`
            : "Aucune app a afficher."}
      </p>
    );
  }

  return (
    <div className="flex flex-col">
      {apps.map((app) => (
        <AppRow
          key={app.id}
          icon={app.icon}
          name={app.label}
          onClick={() => onPickApp(app.id)}
        />
      ))}
    </div>
  );
}
